import React, { useState } from 'react';
import { useField } from 'react-final-form';

import { InputReg } from '@interlayer/js/app/components/main/Registration/components/common/InputReg';
import { TooltipPassword } from '@interlayer/js/app/components/main/Registration/components/common/TooltipPassword';

import { useTranslations } from '@core/js/hooks/i18n';

import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import { getPasswordCriteria } from '@interlayer/js/app/hooks/useValidationRules/utils/validationRules';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TPasswordFieldsProps } from './types';

import style from './PasswordFields.scss';

export const PasswordFields: React.FC<TPasswordFieldsProps> = ({
    isHiddenTooltip,
    labelPassword,
    labelConfirmPassword,
    classNames = {}
}) => {
    const t = useTranslations('playtech.mobile.system.registration.');
    const [isShowTooltipPassword, setIsShowTooltipPassword] = useState(false);
    const passwordCriteria = getPasswordCriteria(t);
    const { input: { value: passwordValue } } = useField(VALIDATION_FIELDS.password);
    const handlerShowTooltip = (isShow: boolean) => () => {
        setIsShowTooltipPassword(isShow);
    };

    return (
        <>
            <div className={clsx(style.passwordWrap, classNames.passwordWrap)}>
                <InputReg
                    type="password"
                    name={VALIDATION_FIELDS.password}
                    autoComplete="new-password"
                    placeholder={labelPassword}
                    onFocus={handlerShowTooltip(true)}
                    onBlur={handlerShowTooltip(false)}
                    classNames={classNames}
                />

                {!isHiddenTooltip && (
                    <TooltipPassword
                        password={passwordValue}
                        criteria={passwordCriteria}
                        isShow={isShowTooltipPassword}
                        classNames={classNames}
                    />
                )}
            </div>

            <InputReg
                classNames={classNames}
                isDisabledCopyPast
                placeholder={labelConfirmPassword}
                type="password"
                name={VALIDATION_FIELDS.confirmPassword}
                autoComplete="new-password"
            />
        </>
    );
};
